"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _commonUtility = require("../utils/commonUtility");

var _Row = _interopRequireDefault(require("../Layout/Row"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _RadioIcon = _interopRequireDefault(require("./RadioIcon"));

var _useHover3 = _interopRequireDefault(require("../useHover"));

var _excluded = ["id", "onChange", "value", "name", "children", "style", "className", "jss", "disabled", "checked"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      position: 'relative',
      cursor: 'pointer'
    },
    radio: {
      height: 16,
      width: 16
    },
    disabled: {
      cursor: 'not-allowed',
      color: theme.palette.text.placeholder
    },
    input: {
      cursor: 'inherit',
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0,
      zIndex: 1
    }
  };
}, {
  name: 'Radio'
});
exports.useStyles = useStyles;

var Radio = /*#__PURE__*/_react["default"].forwardRef(function Radio(_ref, ref) {
  var id = _ref.id,
      onChange = _ref.onChange,
      value = _ref.value,
      name = _ref.name,
      children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      jss = _ref.jss,
      disabled = _ref.disabled,
      checked = _ref.checked,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });

  var _useHover = (0, _useHover3["default"])(),
      _useHover2 = (0, _slicedToArray2["default"])(_useHover, 2),
      isHovering = _useHover2[0],
      hoverRef = _useHover2[1];

  var inputId = (0, _react.useMemo)(function () {
    return id || (0, _commonUtility.uuid)();
  }, [id]);
  return /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: inputId
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    ref: hoverRef,
    align: "center",
    className: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, classes.disabled, disabled), className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "secondary",
    size: "sm",
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RadioIcon["default"], {
    isHovering: isHovering,
    disabled: disabled,
    className: classes.radio,
    checked: checked
  }), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
    id: inputId,
    ref: ref,
    type: "radio",
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    className: classes.input,
    name: name,
    value: value
  })))), children && /*#__PURE__*/_react["default"].createElement(_TextField["default"], null, children)));
});

Radio.displayName = 'Radio';
var _default = Radio;
exports["default"] = _default;